import "./index.scss";

import React from "react";

import { useAppStore } from "../../../stores";

export default function Component() {
	const appStore = useAppStore((state) => state);

	return (
		<div className="footer-bottom">
			<div className="container">
				<div className="col-12 mb-5">
					<p className="text-white">{appStore.siteData?.footerDescription}</p>
				</div>
				<div className="row align-items-center">
					<div className="col-12 col-md-6 text-center text-md-end">
						<p>Copyright ©{new Date().getFullYear()}</p>
					</div>
					<div className="col-12 col-md-6 text-center text-md-end">
						<p>{appStore.siteData?.developed}</p>
					</div>
				</div>
			</div>
		</div>
	);
}
